import * as React from 'react';

export const EmptyStateImage = () => (
  <svg width="365" height="202" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <rect stroke="currentColor" strokeWidth="3" x="1.5" y="1.5" width="362" height="199" rx="6" />
      <path
        d="M124.389 70.97a6 6 0 1 0-4.88-3.547l-14.222 24.619a5.975 5.975 0 0 0-3.201 1.41l-9.094-6.134a6 6 0 1 0-11.913.657l-11.857 11.45a6 6 0 1 0 3.721 4.747l11.96-11.549c.653.244 1.36.377 2.097.377.98 0 1.904-.235 2.72-.65l10.442 7.042a6 6 0 1 0 10.668-4.952l13.559-23.47zM98.5 180C55.146 180 20 144.854 20 101.5S55.146 23 98.5 23 177 58.146 177 101.5 141.854 180 98.5 180zM63 121a2 2 0 0 0-2 2v18h14v-18a2 2 0 0 0-2-2H63zm20-16a2 2 0 0 0-2 2v34h14v-34a2 2 0 0 0-2-2H83zm19 7a2 2 0 0 0-2 2v27h14v-27a2 2 0 0 0-2-2h-10zm19-25a2 2 0 0 0-2 2v52h14V89a2 2 0 0 0-2-2h-10zm-67 54v4h87v-4H54zM231.77 141.23V63H228v82h82v-3.77h-78.23zM266.5 180c-43.354 0-78.5-35.146-78.5-78.5S223.146 23 266.5 23 345 58.146 345 101.5 309.854 180 266.5 180zm-31.135-62.07l16.718 9.045 12.824-16.063 17.14 5.098 13.014-17.204 13.972-6.808.79-25.319-16.27 7.634-12.751 17.685-17.75-5.285-12.58 16.596-15.107-9.297v23.919zM235 138.253h74.458l-.514-41.222-10.9 4.19-14.9 19.4-17.115-4.743-13.055 16.154L235 122.137v16.115z"
        fill="currentColor"
      />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/EmptyStateImage.tsx